export const calendarReminderOptions = [5, 15, 30, 60]

export const calendarSecondReminderOptions = [0, 15, 30, 45, 60]
